import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {IsAdminGuard} from './guards/is-admin.guard';
import {IsAnonymousGuard} from './guards/is-anonymous.guard';
import {IsAuthenticatedGuard} from './guards/is-authenticated.guard';
import {I18nDirective} from './i18n.directive';
import {AuthInterceptor} from './interceptors/auth.interceptor';
import {ErrorInterceptor} from './interceptors/error.interceptor';
import {GlobalOptionsInterceptor} from './interceptors/global-options.interceptor';
import {LoadingInterceptor} from './interceptors/loading.interceptor';
import {PhoneTypePipe} from './pipes/phone-type.pipe';
import {PortalAuthService} from './portal-auth.service';
import {ContractService} from './providers/contract.service';
import {GeoService} from './providers/geo.service';
import {LoadingService} from './providers/loading.service';

@NgModule({
  declarations: [PhoneTypePipe, I18nDirective],
  exports: [PhoneTypePipe, I18nDirective],
  imports: [CommonModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalOptionsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    GeoService,
    ContractService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class PortalCommonsModule {
  static forRoot(): ModuleWithProviders<PortalCommonsModule> {
    return {
      ngModule: PortalCommonsModule,
      providers: [
        PortalAuthService,
        LoadingService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: GlobalOptionsInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorInterceptor,
          multi: true,
        },
        IsAuthenticatedGuard,
        IsAnonymousGuard,
        IsAdminGuard,
      ],
    };
  }
}
